import PropTypes from 'prop-types';
import { t } from 'bv-i18n';
import { Icon } from 'bv-components';
import { toCurrency } from 'bv-helpers/number';

const BalanceView = ({
  showBalance,
  setShowBalance,
  balance: {
    decimalMainBalance,
    decimalBonusBalance,
  },
}) => (
  <div className="site-header-balance-wrapper">
    {showBalance ? (
      <div className="site-header-balance bvs-link" onClick={() => { setShowBalance(false); }}>
        <div className="site-header-balance__bonus-balance">
          {' '}
          <Icon className="bonus-cash-icon" id="bonus-cash" />
          <span>{toCurrency(decimalBonusBalance, { decimalPlaces: 2 })}</span>
        </div>
        <div className="site-header-balance__main-balance">
          {' '}
          <span>{toCurrency(decimalMainBalance, { decimalPlaces: 2 })}</span>
        </div>
      </div>
    ) : (
      <div className="site-header-balance bvs-link" onClick={() => { setShowBalance(true); }}>
        <div className="site-header-balance__main-balance is-hidden">
          {t('show_balance')}
        </div>
      </div>
    )}
  </div>
);

BalanceView.propTypes = {
  showBalance: PropTypes.bool.isRequired,
  setShowBalance: PropTypes.func.isRequired,
  balance: PropTypes.shape({
    decimalMainBalance: PropTypes.number.isRequired,
    decimalBonusBalance: PropTypes.number.isRequired,
  }).isRequired,
};

export default BalanceView;
